import styled from '@emotion/styled';
import React from 'react';
import { Stack } from '../stack';
import { ColorChip } from './ColorChip';
import { FormLabel } from '../form';
import { PresetType } from './types';

export interface PresetProps {
  /**
   * @desc hex 컬러 코드 (ex: #000000)
   */
  selected_color?: string;
  onSelect(color: string): void;
  preset?: PresetType[];
}

export const Preset: React.FC<PresetProps> = ({ selected_color, onSelect, preset }) => {
  return (
    <Stack direction='column' gap={16}>
      {preset?.map(({ label, colors }) => (
        <Stack key={label} direction='column' gap={8} data-testid={`color-picker-preset-${label}`}>
          <FormLabel>{label}</FormLabel>
          <PresetChips>
            {colors.map(({ label, color, displayedColor, disabled }) => (
              <ColorChip
                key={color}
                label={label}
                color={color.toUpperCase()}
                displayedColor={displayedColor || color}
                onClick={onSelect}
                disabled={disabled}
                selected={selected_color?.toUpperCase() === color.toUpperCase()}
              />
            ))}
          </PresetChips>
        </Stack>
      ))}
    </Stack>
  );
};

const PresetChips = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;
